export const baseUrl = "https://millgrader-backend.vulcan-ai.com";
// export const baseUrl = "http://localhost:4000";
